
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visit",
      function () {
        return require("private-next-pages/visit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visit"])
      });
    }
  